import { WorkbookDynamicBarChartComponent } from './../../misc/workspace/workbook-dynamic-charts/workbook-dynamic-bar-chart/workbook-dynamic-bar-chart.component';
import { WorkbookDynamicChartsAddComponent } from './../../misc/workspace/workbook-dynamic-charts/workbook-dynamic-charts-add/workbook-dynamic-charts-add.component';
import { QuestionnaireResponsesComponent } from './../../more/questionnaire/questionnaire-responses/questionnaire-responses.component';
import { ImportAvailableColumnsFilterPipe } from './pipes/import-available-columns-filter.pipe';
import { OnlyTimePipe } from './pipes/only-time.pipe';
import { ImportMappedColumnsFilterPipe } from './pipes/import-mapped-columns-filter.pipe';
import { SavedSearchTableViewComponent } from './../../misc/saved-searches/components/saved-search-table-view/saved-search-table-view.component';
import { SubscriptionLimitMessageComponent } from './components/subscription-limit-message/subscription-limit-message.component';
import { EmailGenerateAiComponent } from './components/shared-emails/email-generate-ai/email-generate-ai.component';
import { SavedSearchGroupByFieldsPipe } from './pipes/saved-search-groupby-fields.pipe';
import { SavedSearchDateTimeLabelPipe } from './pipes/saved-search-dateime-label.pipe';
import { WorkflowActiveModuleActionsPipe } from './pipes/workflow-active-module-actions.pipe';
import { SavedSearchCombineRulesViewPipe } from './pipes/saved-search-combine-rules-view.pipe';
import { WorkflowUpdateOperationTypePipe } from './pipes/workflow-update-operation-type.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { RemoveHtmlTagsPipe } from './pipes/remove-html-tags.pipe';
import { SharedSummaryWidgetComponent } from './components/shared-summary-widget/shared-summary-widget.component';
import { ConvertDateToDhmsPipe } from './pipes/convertDateToDhms.pipe';
import { AddFieldsExpressionDialogComponent } from './components/add-fields-expression-dialog/add-fields-expression-dialog.component';
import { WorkflowQtyDiscountOperatorsPipe } from './pipes/workflow-qty-discount-operators.pipe';
import { WorkflowActiveActionsPipe } from './pipes/workflow-active-actions.pipe';
import { MassEditAvailableFieldsPipe } from './pipes/mass-edit-available-fields.pipe';
import { NumberToFixedPipe } from './pipes/number-tofixed.pipe';
import { CustomNumberFormatPipe } from './pipes/custom-number-format.pipe';
import { TerritoryLeadAccountMapViewComponent } from '../../more/territory/compoment/territory-lead-account-map-view/territory-lead-account-map-view.component';
import { EditAccountComponent } from '../../accounts-v2/components/edit-account/edit-account.component';
import { ActivityByPipe } from './pipes/activity-by.pipe';
import { LeadAccountEmailValidatorDirective } from './directives/lead-account-email-validator.directive';
import { WorkflowUpdateFieldValuePipe } from './pipes/workflow-update-filed-value.pipe';
import { OnlyNumberDirective } from './directives/only-numbers.directive';
import { SavedSearchPreviewModalComponent } from '../../misc/saved-searches/components/saved-search-preview-modal/saved-search-preview-modal.component';
import { DateAsAgoPipe } from './pipes/date-as-ago.pipe';
import { DateAsAgoWithTimezonePipe } from './pipes/date-as-ago-with-timezone.pipe';
// Modules
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { PrimngDesignModule } from '../primng-design/primng-design.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { GridsterModule } from 'angular-gridster2';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ListboxModule } from 'primeng/listbox';
import { SkeletonModule } from 'primeng/skeleton';
import { CdTimerModule } from 'angular-cd-timer';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputNumberModule } from 'primeng/inputnumber';

// Components
import { SharedMassEditComponent } from './components/shared-mass-edit/shared-mass-edit.component';
import { SharedMassEditHistoryComponent } from './components/shared-mass-edit-history/shared-mass-edit-history.component';
import { AddEditContactModalComponent } from './components/add-edit-contact-modal/add-edit-contact-modal.component';
import { BarChartComponent } from '../../widgets/charts/bar/bar.chart.component';
import { DoughnutChartComponent } from '../../widgets/charts/doughnut/doughnut.chart.component';
import { LoginComponent } from '../../login/login.component';
import { PieChartComponent } from '../../widgets/charts/pie/pie.chart.component';
import { LionTreeSelectComponent } from './components/p-treeselect/p-treeselect.component';
import { ProductSelectionModalComponent } from './components/product-selection-modal/product-selection-modal.component';
import { ImportComponent } from './components/import/import.component';
import { AppSettingModalComponent } from './components/setting-modal/app.setting.modal.component';
import { AppManualModalComponent } from './components/manual-modal/app.manual.modal.component';
import { NameAvatarComponent } from './components/name-avatar/name-avatar.component';
import { AppColorBoxComponent } from './components/color-box/app.color.box.component';
import { AppRuleSelectionModalComponent } from './components/rule-selection/app.rule.selection.modal.component';
import { SharedActivitiesTimelineComponent } from './components/shared-activities/shared-activities-timeline/shared-activities-timeline.component';
import { SharedActivityListTemplateComponent } from './components/shared-activities/shared-activity-list-template/shared-activity-list-template.component';
import { SharedActivitiesListComponent } from './components/shared-activities/shared-activities-list/shared-activities-list.component';
import { LionSharedLogsComponent } from './components/shared-logs/shared-logs.component';
import { LionLogDetailsComponent } from './components/shared-logs/log-details/log-details.component';
import { LionSharedActivitiesComponent } from './components/shared-activities/shared-activities.component';
import { LionSharedTaskListingComponent } from './components/shared-task-listing/shared-task-listing.component';
import { LionSharedNotesComponent } from './components/shared-notes/shared-notes.component';
import { LionNoteDetailsComponent } from './components/shared-notes/note-details/note-details.component';
import { LionSharedEventsComponent } from './components/shared-events/shared-events.component';
import { LionAppCommentModalComponent } from './components/shared-comment-modal/app.comment.modal.component';
import { LionSharedEmailsComponent } from './components/shared-emails/shared-emails.component';
import { LionSharedEmailThreadsListComponent } from './components/shared-emails/shared-email-threads-list/shared-email-threads-list.component';
import { LionSharedEmailThreadDetailsComponent } from './components/shared-emails/shared-email-thread-details/shared-email-thread-details.component';
import { LionEmailComposeFormComponent } from './components/shared-emails/email-compose-form/email-compose-form.component';
import { LionAttachmentChipsComponent } from './components/attachment-chips/attachment-chips.component';
import { LionoSharedSystemActivitiesComponent } from './components/shared-system-activities/shared-system-activities.component';
import { LionWidget1Component } from './widgets/charts/widget1/widget1.component';
import { LionWidget2Component } from './widgets/charts/widget2/widget2.component';
import { LionWidget3Component } from './widgets/charts/widget3/widget3.component';
import { LionWidget4Component } from './widgets/charts/widget4/widget4.component';
import { LionWidget4aComponent } from './widgets/charts/widget4a/widget4.component';
import { LionWidget5Component } from './widgets/charts/widget5/widget5.component';
import { LionWidget6Component } from './widgets/charts/widget6/widget6.component';
import { LionWidget7Component } from './widgets/charts/widget7/widget7.component';
import { LionWidget8Component } from './widgets/charts/widget8/widget8.component';
import { LionWidget9Component } from './widgets/charts/widget9/widget9.component';
import { LionWidget10Component } from './widgets/charts/widget10/widget10.component';
import { LionWidget11Component } from './widgets/charts/widget11/widget11.component';
import { LionWidget12Component } from './widgets/charts/widget12/widget12.component';
import { LionWidget13Component } from './widgets/dataTable/widget13/widget13.component';
import { LionWidget14Component } from './widgets/dataTable/widget14/widget14.component';
import { LionWidget15Component } from './widgets/dataTable/widget15/widget15.component';
import { LionWidget16Component } from './widgets/dataTable/widget16/widget16.component';
import { LionWidget17Component } from './widgets/dataTable/widget17/widget17.component';
import { LionWidget18Component } from './widgets/dataTable/widget18/widget18.component';
import { LionWidget19Component } from './widgets/dataTable/widget19/widget19.component';
import { LionWidget20Component } from './widgets/dataTable/widget20/widget20.component';
import { LionWidget21Component } from './widgets/dataTable/widget21/widget21.component';
import { LionWidget22Component } from './widgets/dataTable/widget22/widget22.component';
import { LionWidget23Component } from './widgets/dataTable/widget23/widget23.component';
import { LionWidget24Component } from './widgets/dataTable/widget24/widget24.component';
import { LiongmPlaceAutocompleteComponent } from './components/shared-gm-place-autocomplete/gm-place-autocomplete.component';
import { LionSharedContactsComponent } from './components/shared-contacts/shared-contacts.component';
import { AppQuestionnaireModalComponent } from './components/shared-questionnaire-modal/app.questionnaire.modal.component';
import { LionAddressGridComponent } from './components/address/address-grid/address-grid.component';
import { LionAddEditAddressModalComponent } from './components/address/address-add-update-modal/address-add-update-modal.component';
import { LionAddressTypeModalComponent } from './components/address/address-type-modal/address-type-modal.component';
import { DetailsTaskComponent } from './components/details-task/details-task.component';
// import { AppImportModalComponent } from './components/import-modal/app.import.modal.component';
import { SharedImportModalComponent } from './components/shared-import-modal/shared-import-modal.component';
import { SharedImportSampleModalComponent } from './components/shared-import-sample-modal/shared-import-sample-modal.component';
import { SharedImportFieldMappingComponent } from './components/shared-import-field-mapping/shared-import-field-mapping.component';
import { SharedDetailBlockComponent } from './components/shared-detail-block/shared-detail-block.component';
import { StepsModule } from 'primeng/steps';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { GlobalSearchTableComponent } from './components/global-search-table/global-search-table.component';
import { SharedDetailPopupComponent } from './components/shared-detail-popup/shared-detail-popup.component';
import { LionAllActivitiesDialogComponent } from './components/shared-activities/all-activities-dialog/all-activities-dialog.component';
import { LionSharedActivitySidebarComponent } from './components/shared-activities/activity-sidebar/activity-sidebar.component';
import { LionLogDetailsPopupComponent } from './components/shared-activities/log-details-popup/log-details.component';
import { SendEmailComponent } from './components/send-email/send-email.component';
import { PrintComponent } from './components/print/print.component';
import { LionNoteDetailsPopupComponent } from './components/shared-activities/note-details-popup/note-details.component';
import { LionEmailDetailsPopupComponent } from './components/shared-activities/email-details-popup/email-details.component';
import { LionActiveInActiveModalComponent } from './components/active-inactive-modal/active-inactive-modal.component';
import { AccountsDetailsComponent } from '../../accounts-v2/components/accounts-details/accounts-details.component';
import { AccountInventoryDetailsComponent } from '../../accounts-v2/components/accounts-details/account-inventory-details/account-inventory-details.component';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { AttachmentListComponent } from './components/attachment-list/attachment-list.component';
import { FileOpnerComponent } from './components/file-opener/file-opener.component';
import { BlockContentSpinnerComponent } from './components/block-content-spinner/block-content-spinner.component';
import { EmailReplyPopupComponent } from './components/shared-activities/email-reply-popup/email-reply.component';
import { ElasticGlobalSearchComponent } from './components/elastic-global-search/elastic-global-search.component';
import { SharedCustomFieldsComponent } from './components/shared-custom-fields/shared-custom-fields.component';
import { SharedColumnSettingsComponent } from './components/column-settings-modal/column-settings-modal.component';
import { SharedExportModalComponent } from './components/export-modal-new/export-modal.component';
import { AddEditFinanceAccountModalComponent } from './components/add-edit-finance-account-modal/add-edit-finance-account-modal.component';
import { InventoryAdjustmentViewComponent } from './components/inventory-adjustment-view/inventory-adjustment-view.component';
import { InventoryTransferViewComponent } from './components/inventory-transfer-view/inventory-transfer-view.component';
import { InvoiceOverviewComponent } from './components/invoice-overview/invoice-overview.component';
import { InvoiceAddEditComponent } from './components/invoice-add-edit/invoice-add-edit.component';
import { EstimatesOverviewComponent } from './components/estimates-overview/estimates-overview.component';
import { CreditMemoOverviewComponent } from './components/credit-memo-overview/credit-memo-overview.component';
import { SalesOrderOverviewComponent } from './components/sales-order-overview/sales-order-overview.component';
import { PurchaseOrderOverviewComponent } from './components/purchase-order-overview/purchase-order-overview.component';
import { ReceivePaymentViewComponent } from './components/receive-payment-view/receive-payment-view.component';
import { JournalEntryViewComponent } from './components/journal-entry-view/journal-entry-view.component';
import { CustomAttributeOverviewComponent } from './components/custom-attribute-overview/custom-attribute-overview.component';
import { EasypostShipmentComponent } from './components/easypost-shipment/easypost-shipment.component';
import { FedexShipmentComponent } from './components/fedex-shipment/fedex-shipment.component';
import { UpsShipmentComponent } from './components/ups-shipment/ups-shipment.component';
import { BillPaymentViewComponent } from './components/bill-payment-view/bill-payment-view.component';
import { BillViewComponent } from './components/bill-view/bill-view.component';
import { ItemReceiptViewComponent } from './components/item-receipt-view/item-receipt-view.component';
import { AccountLeadDetailBlockComponent } from './components/account-lead-detail-block/account-lead-detail-block.component';
import { LeadsFullDetailsComponent } from '../../leads-v2/components/leads-full-details/leads-full-details.component';
import { SharedCustomFieldsTemplateComponent } from './components/shared-custom-fields-template/shared-custom-fields-template.component';
import { AddTagDialogComponent } from './components/add-tag-dialog/add-tag-dialog.component';
import { AssignTagDialogComponent } from './components/assign-tag-dialog/assign-tag-dialog.component';
import { ChatBotModalComponent } from './components/chatbot-modal/chatbot-modal.component';
import { SerialDetailsBlockComponent } from './components/serial-details-block/serial-details-block.component';
import { SalesHistoryComponent } from './components/sales-history/sales-history.component';
import { PurchaseHistoryComponent } from './components/purchase-history/purchase-history.component';
import { EstimatesAddEditComponent } from './components/estimates-add-edit/estimates-add-edit.component';
import { AccountAssociatedOpportunityModalComponent } from './components/account-associated-opportunity-modal/account-associated-opportunity-modal.component';
import { CommonProductAddFormComponent } from './components/common-product-add-form/common-product-add-form.component';
import { SoPdfComponent } from './components/so-pdf/so-pdf.component';
import { SharedContactsV1Component } from './components/shared-contacts-v1/shared-contacts-v1.component';
import { AppExportService } from './components/export-modal/app.export.service';
import { AppExportModalComponent } from './components/export-modal/app.export.modal.component';
import { ElasticGlobalSearchService } from './components/elastic-global-search/services/elastic-global-search.service';
import { AppSettingService } from './components/setting-modal/app.setting.service';
import { AccountsHttpService } from './services/accounts.http.service';
import { ContactHttpService } from './services/contact.http.service';
import { CoreHttpService } from './services/core.http.service';
import { StoreService } from './services/store.service';
import { AddEditAddressModalService } from './components/address/address-add-update-modal/address-add-update-modal.service';
import { AddressGridService } from './components/address/address-grid/address-grid.component.service';
import { AddressTypeService } from './components/address/address-type-modal/address-type-modal.service';
import { AppManualService } from './components/manual-modal/app.manual.service';
import { AppRuleSelectionService } from './components/rule-selection/app.rule.selection.service';
import { SharedSystemActivitiesService } from './components/shared-system-activities/shared-system-activities.service';
import { AppDecimalNumbersDirective } from './directives/decimal-numbers.directive';
import { LogService } from './components/shared-logs/log-service.service';
import { TaskService } from './api/task.service';
import { NoteService } from './api/note.service';
import { EmailService } from './components/shared-emails/email.service';
import {
  GroupService,
  TypeService,
  ObjectTaskService,
  TaskCategoryService,
  ObjectNoteService,
  ObjectEmailAuditService,
  RepeatTypeService,
} from './api/api';
import {
  CategoryService,
  StatusService,
  VendorService,
  VendorOAuthRegistrationUserService,
} from './components/shared-emails/api/api';
import { VendorOAuthRegistrationService } from './components/shared-emails/api/vendorOAuthRegistration.service';
import { GlobalSearchService } from './components/global-search/global-search.service';
import { SharedInventoryServices } from './services/inventory.service';
import { AccountLeadDataService } from './stores/accountLeadDataStore/accountLeadData.service';
import { SharedDataService } from './stores/sharedDataStore/sharedData.service';
import { TaskDataService } from './stores/taskDataStore/taskData.service';
import { LogOutService } from './stores/logOut/logOut.service';
import { HttpService } from './services/http.service';
import { SharedExportService } from './services/export-modal.service';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TimelineModule } from 'primeng/timeline';

// Pipes
import { AppGlobalFilter } from './pipes/global.filter';
import { AppShortenFilter } from './pipes/shorten.filter';
import { CurrencySymbolPipe } from './pipes/currency-symbol.pipe';
import { MulticurrencyPipe } from './pipes/multicurrency.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { PercentageSymbolPipe } from './pipes/percentage-symbol.pipe';
import { NumberWithPercentageSymbolPipe } from './pipes/number-with-percentage-symbol.pipe';
import { SecsToDhmsPipe } from './pipes/secsToDhms.pipe';
import { UrlPipe } from './pipes/url.pipe';
import { LionGlobalFilter } from './pipes/shared-global-filter.pipe';
import { AddressFilterPipe } from './pipes/address-filter.pipe';
import { HtmlToPlaintextPipe } from './pipes/html-to-plaintext.pipe';
import { StatusFilterPipe } from './pipes/status.filter.pipe';
import { StatusRemovedFilterPipe } from './pipes/status-removed.filter.pipe';
import { PhoneValidationPipe } from './pipes/phone-validation-message.pipe';
import { FileSizePipe } from './pipes/fileSize.pipe';
import { OrderOtherActivitiesPipe } from './pipes/order-other-activities.pipe';
import { OrderUpcomingTasksPipe } from './pipes/order-tasks.pipe';
import { TimeConvertPipe } from './pipes/timeConvert.pipe';
import { GlobalSearchModuleFilterPipe } from './pipes/global-search-module-filter.pipe';
import { GlobalSearchFieldFilterPipe } from './pipes/global-search-fields-filter.pipe';
import { LeadClosedStageFilterPipe } from './pipes/lead-closed-stage-filter.pipe';
import { InitialsPipe } from './pipes/initial.pipe';
import { SanitizeUrlPipe } from './pipes/sanitize-url.pipe';

// Directives
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { PrintDirective } from './directives/print.directive';
import { FloatTheadDirective } from './directives/float-thead.directive';
import { SharedAssociatedUsers } from './components/associated-users/associated-users.component';
import { FinanceTransactionAvailabilityModalComponent } from './components/finance-transaction-availability-modal/finance-transaction-availability-modal.component';
import { ColumnSettingsModalForRulesComponent } from './components/column-settings-modal-for-rules/column-settings-modal-for-rules.component';
import { ProductsTaxSplitViewComponent } from './components/products-tax-split-view/products-tax-split-view.component';
import { SavedSearchMainModuleRulesSelectionComponent } from './components/saved-search-rules/saved-search-main-module-rules-selection/saved-search-main-module-rules-selection.component';
import { SavedSearchAddedRulesTableComponent } from './components/saved-search-rules/saved-search-added-rules-table/saved-search-added-rules-table.component';
import { ImportSeriesComponent } from './components/import-series/import-series.component';
import { ViewtrackingComponent } from './components/viewtracking/viewtracking.component';
import { BarcodeProductSearchComponent } from './components/barcode-product-search/barcode-product-search.component';
import { ProductSelectionService } from './services/product-selection.service';
import { TrackingDetailsViewComponent } from './components/tracking-details-view/tracking-details-view.component';
import { ConfigExternalClientComponent } from './components/config-external-client/config-external-client.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FilterComponent } from '../../reports/filter/filter.component';
import { DocumentViewerService } from './services/document-viewer.service';
import { LeadDetailDocumentsComponent } from 'src/app/leads-v2/components/lead-detail-documents/lead-detail-documents.component';
import { AccountDetailTableComponent } from '../../accounts-v2/components/accounts-details/table/table.component';
import { ValidatorBaseDirective } from './directives/validator-base.directive';
import { SplitTextByCommaPipe } from './pipes/split-text-by-comma.pipe';
import { UserPreferenceComponent } from 'src/app/profile/user-preference/user-preference.component';
import { AddUpdateViewLeadComponent } from 'src/app/leads-v2/components/add-update-view-lead/add-update-view-lead.component';
import { OpportunityAddEditDialogComponent } from '../../opportunities-v2/components/opportunity-add-edit-dialog/opportunity-add-edit-dialog.component';
import { ItemHistoryComponent } from './components/item-history/item-history.component';
import { AccountRelationAccessComponent } from './components/account-relation-access/account-relation-access.component';
import { CookieService } from 'ngx-cookie-service';
import { BinViewComponent } from './components/bin-view/bin-view.component';
import { CasesAddEditDialogComponent } from '../../cases-v2/components/cases-add-edit-dialog/cases-add-edit-dialog.component';
import { TagModule } from 'primeng/tag';
import { AppliedAmountViewModalComponent } from './components/applied-amount-view-modal/applied-amount-view-modal.component';
import { ReceivePaymentsComponent } from './components/receive-payments/receive-payments.component';
import { NameShortenerPipe } from 'src/app/shared/pipes/name-shortener.pipe';
import { CampaignInboxComponent } from './components/inbox/inbox.component';
import { ReturnDetailsViewComponent } from './components/return-details-view/return-details-view.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { WriteCheckComponent } from './components/write-check/write-check.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { BadgeModule } from 'primeng/badge';
import { CarouselModule } from 'primeng/carousel';

import { FunnelChartComponent } from './charts/funnel-chart/funnel-chart.component';
import { AddEditRouteComponent } from 'src/app/more/route-management/components/add-edit-route/add-edit-route.component';
import { LowercaseUnderscoreDirective } from './directives/lowercase-underscore.directive';
import { AddeditBillpayComponent } from './components/addedit-billpay/addedit-billpay.component';
import { EditItemreceiptComponent } from './components/edit-itemreceipt/edit-itemreceipt.component';
import { MergebillComponent } from './components/mergebill/mergebill.component';
import { EditBillComponent } from './components/edit-bill/edit-bill.component';
import { EditExchangerateComponent } from './components/edit-exchangerate/edit-exchangerate.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { InventoryModuleOverviewDialogsComponent } from './components/inventory-module-overview-dialogs/inventory-module-overview-dialogs.component';
import { AddExpenseComponent } from './components/add-expense/add-expense.component';
import { AddCreditCardChargeComponent } from './components/add-credit-card-charge/add-credit-card-charge.component';
import { AuthenticationSetupComponent } from 'src/app/login/components/authentication-setup/authentication-setup.component';
import { UserRegisterComponent } from './components/user-register/user-register.component';
import { TabViewModule } from 'primeng/tabview';
import { InputMaskModule } from 'primeng/inputmask';

import { UpdateOpeningBalanceComponent } from './components/update-opening-balance/update-opening-balance.component';
import { ApplyCreditMemoComponent } from './components/apply-credit-memo-modal/apply-credit-memo.component';
import { AlphaNumericValidatorDirective } from './directives/alpha-numeric.directive';
import { PosStoredComponent } from './components/pos-stored/pos-stored.component';
import { PosDetailsComponent } from './components/pos-details/pos-details.component';
import { PosViewComponent } from './components/pos-view/pos-view.component';
import { PhoneNumberPipe } from './pipes/phone-number-format.pipe';
import { AudioRecordingService } from './components/inbox/audio-recording.service';
import { AddEditContactsListComponent } from 'src/app/misc/campaign/components/add-edit-contacts-list/add-edit-contacts-list.component';
import { ContactSelectionModalComponent } from './components/contact-selection-modal/contact-selection-modal.component';
import { LocationViewEditComponent } from './components/location-view-edit/location-view-edit.component';
import { SharedCreateTaskComponent } from './components/shared-task/shared-create-task/shared-create-task.component';
import { VendorViewEditComponent } from './components/vendor-view-edit/vendor-view-edit.component';
import { MakeDepositComponent } from './components/make-deposit/make-deposit.component';
import { EditFlowComponent } from '../../misc/campaign/components/edit-flow/edit-flow.component';
import { TransferFundsComponent } from './components/transfer-funds/transfer-funds.component';
import { ActivationResidualDetailsComponent } from './components/activation-residual-details/activation-residual-details.component';
import { ChipModule } from 'primeng/chip';
import { WorkflowApprovalsGroupPipe } from './pipes/workflow-approvals-group.pipe';
import { AddeditBatchComponent } from './components/addedit-batch/addedit-batch.component';
import { RevertSerialImportComponent } from './components/revert-serial-import/revert-serial-import.component';
import { AssignUsersComponent } from './components/assign-users/assign-users.component';
import { FilterTaskOptionsPipe } from './pipes/filter-task-options.pipe';
import { FilterGroupTaskOptionsPipe } from './pipes/filter-task-options-group.pipe';
import { AddEditSubTaskComponent } from './components/details-task/add-edit-sub-task/add-edit-sub-task.component';
import { PlotlyModule } from 'angular-plotly.js';
import * as PlotlyJS from 'plotly.js-dist-min';
import { VendorReturnAddEditComponent } from './components/add-edit/add-edit.component';
import { VendorCreditAddEditComponent } from './components/vendor-credit-add-edit/vendor-credit-add-edit.component';
import {ApprovalDetailsComponent} from '../../profile/approval/approval-details/approval-details.component'
import { ApprovalStatusPipe } from './pipes/approval/approval-status.pipe';
import { ApprovalTypePipe } from './pipes/approval/approval-type.pipe';
import { AvatarModule } from 'primeng/avatar';
import { AddEditFormComponent } from './components/shared-contacts-v1/components/add-edit-form/add-edit-form.component';
import { DynamicFormExternalComponent } from './components/dynamic-form-external/dynamic-form-external.component';
import { PredictDialogComponent } from 'src/app/misc/saved-searches/components/predict-dialog/predict-dialog.component';
import { PredictComponent } from 'src/app/misc/saved-searches/components/predict/predict.component';
import { ClosingStatementValidationComponent } from './components/closing-statement-validation/closing-statement-validation.component';
import { QuotationStatusToggleService } from 'src/app/opportunities-v2/components/quotation-listing/services/quotation-status-toggle.service';
import { ProductvisibilityListComponent } from './components/productvisibility-list/productvisibility-list.component';
import { AddToListComponent } from 'src/app/misc/saved-searches/components/add-to-list/add-to-list.component';
import { SavedSearchAddedListComponent } from 'src/app/misc/saved-searches/components/saved-search-added-list/saved-search-added-list.component';
import { SharedWorkbookListingComponent } from './components/shared-workbook-listing/shared-workbook-listing.component';

import { SharedCalendarComponent } from './components/shared-calendar/shared-calendar.component';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { ActivityModuleDetailsPipe } from './pipes/activity-module-details.pipe';
import { PasswordModule } from 'primeng/password';
import { ActivityModuleNamePipe } from './pipes/activity-module-name.pipe';
import { ImportActionFilterPipe } from './pipes/import-action.filter.pipe';
import { DocumentsManagementComponent } from './components/documents-management/documents-management.component';
import { WorkbookReminderComponent } from 'src/app/misc/workspace/workbook-reminder/workbook-reminder.component';
import { UserDetailsModalComponent } from './components/user-details-modal/user-details.component'
import { WorkbookCommentDetailsComponent } from 'src/app/misc/workspace/workbook-comment-details/workbook-comment-details.component';
import { FloatLabelModule } from "primeng/floatlabel"
import { InputOtpModule } from 'primeng/inputotp';
import { QuillModule } from 'ngx-quill';
import { InventoryImpactsGlComponent } from './components/inventory-impacts-gl/inventory-impacts-gl.component';
import { ExportUtilityComponent } from './components/export-utility/export-utility.component';
import { FinancePrintUtilityComponent } from './components/finance-print-utility/finance-print-utility.component';
import { BillingPrintComponent } from './components/billing-print/billing-print.component';
import { ExportConfirmComponent } from './components/export-confirm/export-confirm.component';
import { FeesAndDiscountsManagerComponent } from './components/fees-and-discounts-manager/fees-and-discounts-manager.component';
import { TaxSelectionModalComponent } from './components/tax-selection-modal/tax-selection-modal.component';
import { SublistDetailsPopupComponent } from './components/sublist-details-popup/sublist-details-popup.component';
import { FilterByFormControlTypePipe } from './pipes/filter-by-form-control-type.pipe';
import { SharedWorkbookCellComponent } from './components/shared-workbook-cell/shared-workbook-cell.component';
import { PostingPeriodSelectorComponent } from './components/posting-period-selector/posting-period-selector.component';
PlotlyModule.plotlyjs = PlotlyJS;

const sharedComponents = [
  WorkbookCommentDetailsComponent,
  PredictDialogComponent,
  SharedCalendarComponent,
  WorkbookReminderComponent,
  DocumentsManagementComponent,
  PredictComponent,
  AddEditFormComponent,
  AddEditSubTaskComponent,
  AssignUsersComponent,
  AuthenticationSetupComponent,
  LoginComponent,
  AppSettingModalComponent,
  AppManualModalComponent,
  NameAvatarComponent,
  AppColorBoxComponent,
  AppRuleSelectionModalComponent,
  LionTreeSelectComponent,
  AppExportModalComponent,
  ProductSelectionModalComponent,
  AddEditContactModalComponent,
  ImportComponent,
  SharedActivitiesTimelineComponent,
  SharedActivityListTemplateComponent,
  SharedActivitiesListComponent,
  LionSharedLogsComponent,
  LionLogDetailsComponent,
  LionSharedActivitiesComponent,
  SharedCreateTaskComponent,
  LionSharedTaskListingComponent,
  LionSharedNotesComponent,
  LionNoteDetailsComponent,
  LionSharedEventsComponent,
  LionAppCommentModalComponent,
  LionSharedEmailsComponent,
  LionSharedEmailThreadsListComponent,
  LionSharedEmailThreadDetailsComponent,
  LionEmailComposeFormComponent,
  LionAttachmentChipsComponent,
  LionoSharedSystemActivitiesComponent,
  DetailsTaskComponent,
  LionWidget1Component,
  LionWidget2Component,
  LionWidget3Component,
  LionWidget4Component,
  LionWidget4aComponent,
  LionWidget5Component,
  LionWidget6Component,
  LionWidget7Component,
  LionWidget8Component,
  LionWidget9Component,
  LionWidget10Component,
  LionWidget11Component,
  LionWidget12Component,
  LionWidget13Component,
  LionWidget14Component,
  LionWidget15Component,
  LionWidget16Component,
  LionWidget17Component,
  LionWidget18Component,
  LionWidget19Component,
  LionWidget20Component,
  LionWidget21Component,
  LionWidget22Component,
  LionWidget23Component,
  LionWidget24Component,
  BarChartComponent,
  PieChartComponent,
  DoughnutChartComponent,
  LionSharedContactsComponent,
  LiongmPlaceAutocompleteComponent,
  AppQuestionnaireModalComponent,
  GlobalSearchComponent,
  GlobalSearchTableComponent,
//   AppImportModalComponent,
  SharedImportModalComponent,
  SharedImportSampleModalComponent,
  SharedImportFieldMappingComponent,
  SharedDetailBlockComponent,
  SharedDetailPopupComponent,
  LionAllActivitiesDialogComponent,
  LionSharedActivitySidebarComponent,
  LionLogDetailsPopupComponent,
  SendEmailComponent,
  PrintComponent,
  LionAddressGridComponent,
  LionAddEditAddressModalComponent,
  UserPreferenceComponent,
  OpportunityAddEditDialogComponent,
  MakeDepositComponent,
  ExportUtilityComponent,
  FinancePrintUtilityComponent,
  BillingPrintComponent,
  TransferFundsComponent,
  // SavedSearchPreviewModalComponent,
  LionAddressTypeModalComponent,
  LionNoteDetailsPopupComponent,
  LionEmailDetailsPopupComponent,
  LionActiveInActiveModalComponent,
  AccountsDetailsComponent,
  EditAccountComponent,
  AccountInventoryDetailsComponent,
  LeadsFullDetailsComponent,
  SublistDetailsPopupComponent,
  ImageSliderComponent,
  AttachmentListComponent,
  BlockContentSpinnerComponent,
  AddEditFinanceAccountModalComponent,
  InventoryAdjustmentViewComponent,
  InventoryTransferViewComponent,
  InvoiceOverviewComponent,
  InvoiceAddEditComponent,
  EstimatesOverviewComponent,
  CreditMemoOverviewComponent,
  SalesOrderOverviewComponent,
  PurchaseOrderOverviewComponent,
  ItemReceiptViewComponent,
  ReceivePaymentViewComponent,
  JournalEntryViewComponent,
  CustomAttributeOverviewComponent,
  EasypostShipmentComponent,
  FedexShipmentComponent,
  UpsShipmentComponent,
  BillPaymentViewComponent,
  BillViewComponent,
  VendorReturnAddEditComponent,
  VendorCreditAddEditComponent,
  FinanceTransactionAvailabilityModalComponent,
  SharedCustomFieldsComponent,
  SharedAssociatedUsers,
  SharedCustomFieldsTemplateComponent,
  SharedColumnSettingsComponent,
  SharedExportModalComponent,
  AccountLeadDetailBlockComponent,
  ColumnSettingsModalForRulesComponent,
  ProductsTaxSplitViewComponent,
  SavedSearchMainModuleRulesSelectionComponent,
  SavedSearchAddedRulesTableComponent,
  SavedSearchPreviewModalComponent,
  BarcodeProductSearchComponent,
  TrackingDetailsViewComponent,
  ConfigExternalClientComponent,
  AccountDetailTableComponent,
  AddUpdateViewLeadComponent,
  ItemHistoryComponent,
  AccountRelationAccessComponent,
  TerritoryLeadAccountMapViewComponent,
  ReturnDetailsViewComponent,
  WriteCheckComponent,
  SharedMassEditComponent,
  SharedMassEditHistoryComponent,
  AddeditBillpayComponent,
  EditItemreceiptComponent,
  AddFieldsExpressionDialogComponent,
  MergebillComponent,
  EditBillComponent,
  EditExchangerateComponent,
  InventoryModuleOverviewDialogsComponent,
  SharedSummaryWidgetComponent,
  AddExpenseComponent,
  AddCreditCardChargeComponent,
  UserRegisterComponent,
  PosStoredComponent,
  PosDetailsComponent,
  PosViewComponent,
  SerialDetailsBlockComponent,
  EmailGenerateAiComponent,
  ContactSelectionModalComponent,
  LocationViewEditComponent,
  VendorViewEditComponent,
  ActivationResidualDetailsComponent,
  EstimatesAddEditComponent,
  FeesAndDiscountsManagerComponent,
  TaxSelectionModalComponent,
  SoPdfComponent,
  PostingPeriodSelectorComponent,
  ClosingStatementValidationComponent,
  AccountAssociatedOpportunityModalComponent,
  CommonProductAddFormComponent,
  ProductvisibilityListComponent,
  QuestionnaireResponsesComponent,
  WorkbookDynamicChartsAddComponent,
  WorkbookDynamicBarChartComponent,
  // charts
  FunnelChartComponent,
  //pipes
  StripHtmlPipe,
  FileOpnerComponent,
  EmailReplyPopupComponent,
  ElasticGlobalSearchComponent,
  AddEditRouteComponent,
  PhoneNumberPipe,
  UpdateOpeningBalanceComponent,
  // Pipes
  FilterGroupTaskOptionsPipe,
  FilterTaskOptionsPipe,
  AppGlobalFilter,
  AppShortenFilter,
  UrlPipe,
  LocalDatePipe,
  OnlyTimePipe,
  LionGlobalFilter,
  AddressFilterPipe,
  HtmlToPlaintextPipe,
  StatusFilterPipe,
  SplitTextByCommaPipe,
  StatusRemovedFilterPipe,
  PhoneValidationPipe,
  FileSizePipe,
  OrderUpcomingTasksPipe,
  OrderOtherActivitiesPipe,
  AppDecimalNumbersDirective,
  OnlyNumberDirective,
  ValidatorBaseDirective,
  LeadAccountEmailValidatorDirective,
  TimeConvertPipe,
  SecsToDhmsPipe,
  DateAsAgoPipe,
  DateAsAgoWithTimezonePipe,
  GlobalSearchModuleFilterPipe,
  GlobalSearchFieldFilterPipe,
  LeadClosedStageFilterPipe,
  InitialsPipe,
  SanitizeUrlPipe,
  WorkflowUpdateFieldValuePipe,
  ActivityByPipe,
  NumberToFixedPipe,
  NameShortenerPipe,
  MassEditAvailableFieldsPipe,
  WorkflowQtyDiscountOperatorsPipe,
  WorkflowActiveActionsPipe,
  ConvertDateToDhmsPipe,
  SavedSearchCombineRulesViewPipe,
  SavedSearchDateTimeLabelPipe,
  SavedSearchGroupByFieldsPipe,
  SavedSearchTableViewComponent,
  WorkflowActiveModuleActionsPipe,
  SanitizeHtmlPipe,
  RemoveHtmlTagsPipe,
  WorkflowUpdateOperationTypePipe,
  CustomNumberFormatPipe,
  WorkflowApprovalsGroupPipe,
  ImportMappedColumnsFilterPipe,
  ImportAvailableColumnsFilterPipe,
  ActivityModuleDetailsPipe,
  ActivityModuleNamePipe,
  ImportActionFilterPipe,
  FilterByFormControlTypePipe,
  // Directives
  AlphaNumericValidatorDirective,
  PrintDirective,
  FloatTheadDirective,
  CurrencySymbolPipe,
  MulticurrencyPipe,
  PercentageSymbolPipe,
  NumberWithPercentageSymbolPipe,
  ClickOutsideDirective,
  ImportSeriesComponent,
  ViewtrackingComponent,
  FiltersComponent,
  FilterComponent,
  LeadDetailDocumentsComponent,
  BinViewComponent,
  CasesAddEditDialogComponent,
  AppliedAmountViewModalComponent,
  ReceivePaymentsComponent,
  AddTagDialogComponent,
  AssignTagDialogComponent,
  CampaignInboxComponent,
  LowercaseUnderscoreDirective,
  ChatBotModalComponent,
  ApplyCreditMemoComponent,
  SalesHistoryComponent,
  PurchaseHistoryComponent,
  AddEditContactsListComponent,
  SubscriptionLimitMessageComponent,
  EditFlowComponent,
  AddeditBatchComponent,
  RevertSerialImportComponent,
  ApprovalDetailsComponent,
  ApprovalStatusPipe,
  ApprovalTypePipe,
  SharedContactsV1Component,
  // DynamicTableComponent,
  // DynamicTableAddEditFormComponent,
  // DynamicWorkbookFormComponent,
  DynamicFormExternalComponent,
  AddToListComponent,
  SavedSearchAddedListComponent,
  SharedWorkbookListingComponent,
  SharedWorkbookCellComponent,
  InventoryImpactsGlComponent,
  UserDetailsModalComponent,
  ExportConfirmComponent
];

const routes: Routes = [
  { path: 'pos-store', component: PosStoredComponent } // Route for shared component
];

@NgModule({
  declarations: [...sharedComponents],
  imports: [
    PrimngDesignModule,
    FormsModule,
    ReactiveFormsModule,
    QuillModule,
    GridsterModule,
    LayoutModule,
    DragDropModule,
    NgxDocViewerModule,
    StepsModule,
    NgxBarcode6Module,
    ListboxModule,
    SkeletonModule,
    ColorPickerModule,
    CdTimerModule,
    SplitButtonModule,
    InputNumberModule,
    TagModule,
    PickerModule,
    NgxPaginationModule,
    BadgeModule,
    CarouselModule,
    TimelineModule,
    TreeSelectModule,
    TabViewModule,
    InputMaskModule,
    ChipModule,
    PlotlyModule,
    AvatarModule,
    PasswordModule,
    FloatLabelModule,
    InputOtpModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    AppSettingService,
    AppRuleSelectionService,
    AppManualService,
    ProductSelectionService,
    LogService,
    EmailService,
    GroupService,
    ObjectTaskService,
    RepeatTypeService,
    TaskCategoryService,
    TypeService,
    TaskService,
    ObjectNoteService,
    NoteService,
    ObjectEmailAuditService,
    CategoryService,
    StatusService,
    VendorService,
    VendorOAuthRegistrationService,
    VendorOAuthRegistrationUserService,
    SharedSystemActivitiesService,
    AppExportService,
    GlobalSearchService,
    ElasticGlobalSearchService,
    AddEditAddressModalService,
    AddressGridService,
    AddressTypeService,
    SharedInventoryServices,
    AccountsHttpService,
    ContactHttpService,
    CoreHttpService,
    HttpService,
    StoreService,
    AccountLeadDataService,
    SharedDataService,
    QuotationStatusToggleService,
    TaskDataService,
    SharedExportService,
    LogOutService,
    DocumentViewerService,
    CookieService,
    AudioRecordingService,
  ],
  exports: [...sharedComponents, ReactiveFormsModule, FormsModule],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentModule {}
